import { getParameterFromURL } from './getParameterFromUrl';
import { sanitizeTariff } from './parseTariff';

export function determinePaymentVersion(): string {
  const everyV5 = getParameterFromURL('everydoggyV5') === 'true';
  const everyV6 = getParameterFromURL('everydoggyV6') === 'true';
  const everyV10 = getParameterFromURL('everydoggyV10') === 'true';
  const tariff = sanitizeTariff(getParameterFromURL('tariff'));
  const mix = getParameterFromURL('mix');
  const darkTheme = getParameterFromURL('darkTheme');

  if (tariff === 'v8') return 'p2';
  if (tariff === 'v6') return 'p3';
  if (tariff === 'v10') return 'p5';
  if (tariff === 'v14') return 'p6';
  if (tariff === 'v17') return 'p8';
  if (tariff === 'v19') return 'p9';
  if (everyV5 || everyV10) {
    if (!tariff || tariff === 'v21') return 'p10';
    if (tariff === 'v27') return 'p11';
    if (tariff === 'v29') return 'p14';
    if (tariff === 'v31') return mix ? 'p13_mix' : 'p13';
    if (tariff === 'v33') return 'p16';
    if (tariff === 'v35') return 'p13_mix';
    if (tariff === 'v37') return mix ? 'p13_mix' : 'p18';
    if (tariff === 'v39') return 'p19';
    if (tariff === 'v41') return darkTheme ? 'p20_dark' : 'p20';
    if (tariff === 'v43') return 'p24';
    if (tariff === 'v45') return 'p27';
    if (tariff === 'v47') return 'p29';
    if (tariff === 'v48') return 'p30';
    if (tariff === 'v49') return 'p31';
    if (tariff === 'v001') return 'p001';
    if (tariff === 'v002') return 'p002';
    if (tariff === 'v003') return 'p003';
  }
  return 'p1';
}

export function resolvePageAndPaymentVersion(): string | null {
  const config = getParameterFromURL('config');

  let pageUrlValue = 'v1';
  if (config) {
    const pageMapExceptions: Record<string, string> = {
      customV1: 'version1',
      customV2: 'v1',
      customV7: 'v9',
    };
    const customVersionMatch = config.match(/^customV(\d+)$/);
    pageUrlValue = pageMapExceptions[config] ?? (customVersionMatch ? `v${customVersionMatch[1]}` : '');
  }

  // Can't resolve the page part (config present but unrecognized) — let the
  // caller fall back to a stored link instead of emitting a page-less value.
  if (!pageUrlValue) {
    return null;
  }

  return `${pageUrlValue}${determinePaymentVersion()}`;
}
